/*
  ba-coll-filters.js
  WHAT: Opens and closes the mobile filter sheet on collection pages.
  WHY:  Owner 2026-09-30 - "bellroy have the filters as an optioon we cshuld do it like thye do",
        "belroy filter block is in the toolbar". Below 900px the facet block is a bottom sheet
        instead of an always-on wall: measured at 375px it was 9 groups, 38 chips and 870px of
        page, and the first product tile sat at 1,720px. The facets are not gone, they are opt-in.
  WHEN: Added 2026-09-30.
  A11Y: Disclosure, not a modal. aria-expanded on the toggle is the single source of truth;
        Escape and the scrim both close. Focus moves to the sheet's close button on open and
        returns to the toggle on close.

  Above 900px this does nothing: the toggle is display:none, so it cannot be clicked, and the
  aside is the ordinary desktop sidebar.
*/

(function () {
  'use strict';

  var toggle = document.querySelector('[data-coll-filters-toggle]');
  if (!toggle) return;

  var sheetId = toggle.getAttribute('aria-controls');
  var sheet = sheetId ? document.getElementById(sheetId) : null;
  if (!sheet) return;

  var scrim = null;

  function makeScrim() {
    if (scrim) return scrim;
    scrim = document.createElement('div');
    scrim.className = 'ba-coll__filters-scrim';
    // Built here rather than in the section markup so a closed sheet ships no extra DOM, and so
    // the scrim cannot be left behind in the Liquid if this script is ever removed.
    scrim.addEventListener('click', close);
    document.body.appendChild(scrim);
    return scrim;
  }

  function open() {
    if (sheet.classList.contains('is-open')) return;
    var s = makeScrim();
    sheet.classList.add('is-open');
    toggle.setAttribute('aria-expanded', 'true');
    document.body.classList.add('has-coll-filters-open');
    // Next frame, so the scrim transitions in rather than appearing at full opacity.
    requestAnimationFrame(function () { s.classList.add('is-open'); });

    var closeBtn = sheet.querySelector('[data-coll-filters-close]');
    if (closeBtn) closeBtn.focus();
  }

  function close() {
    if (!sheet.classList.contains('is-open')) return;
    sheet.classList.remove('is-open');
    toggle.setAttribute('aria-expanded', 'false');
    document.body.classList.remove('has-coll-filters-open');
    if (scrim) scrim.classList.remove('is-open');

    // preventScroll: returning focus to the toggle would otherwise scroll it into view and move
    // the page under the reader. Same trap as the mobile drawer.
    try {
      toggle.focus({ preventScroll: true });
    } catch (err) {
      toggle.focus();
    }
  }

  toggle.addEventListener('click', function () {
    if (sheet.classList.contains('is-open')) close();
    else open();
  });

  sheet.addEventListener('click', function (e) {
    if (e.target.closest('[data-coll-filters-close]')) close();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && sheet.classList.contains('is-open')) {
      e.preventDefault();
      close();
    }
  });

  // A chip navigates to a filtered URL, so the sheet would be torn down anyway - but closing it
  // first means the page behind is not left scroll-locked if the navigation is slow or cancelled.
  sheet.addEventListener('click', function (e) {
    if (e.target.closest('a[href]')) close();
  });

  // If the viewport crosses into desktop while the sheet is open, the toggle disappears and the
  // aside becomes the sidebar again - clear the lock so the page is not stuck unscrollable.
  window.addEventListener('resize', function () {
    if (window.innerWidth >= 900 && sheet.classList.contains('is-open')) close();
  });
})();
